export enum FileType {
    Undefined,
    DEA222CSOS,
    Invoice,
    PackagingSlip,
    MRADocument,
    DEA41,
    Other
}

export enum FileTypeForDisplaying {
    'Unspecified',
    'DEA 222 / CSOS',
    'Invoice',
    'Packaging Slip',
    'MRA Document',
    'DEA 41',
    'Other'
}